<template>

    <!-- 登录/注册 弹窗 -->
    <el-dialog
      class="custom-dialog custom-dialog-login"
      ref="dialog-login"
      :visible.sync="showLoginDialogFlag"
      :append-to-body="true"
      :modal-append-to-body="false"
      :close-on-press-escape="true"
      :withHeader="false"
      :destroy-on-close="true"
      :show-close="true"
      :close-on-click-modal="true"
      :wrapperClosable="true"
      :width="drawerWidth"
      :top="dialogTop"
      @close="close"
      >
          <div style="font-size: 1.5rem; font-weight: 400;"><span>登录到</span></div>
          <div style="font-weight: 600;color: #366EF4; font-size: 1.5rem; ">MaliMali 码哩写作</div>
          <div style="color: rgba(41,40,43,0.6);font-size: 16px;margin-bottom: 10px;letter-spacing: 2px;">你的创作金手指！</div>
          <div v-if="loginIndex==0" style="display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;">
            <div style="color: rgba(41,40,43,0.6);font-size: 14px;"><span>请使用微信扫一扫登录</span><span style="font-weight: 400;cursor: pointer;
font-size: 14px;
color: #0052D9;padding: 0 5px 0 10px;" @click="loginSwitch(0)">刷新</span><i class="el-icon-refresh pointer" style="color: #0052D9;" @click="loginSwitch(0)"></i></div>
            <img v-if="ticket != ''" style="width: 220px;height: 220px;" :src="'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket='+ ticket" alt="二维码" />
            <div style="height: 220px;" v-else>
              <i class="el-icon-loading" style="color: #0052D9;"></i>
            </div>
          </div>
          <el-form v-if="loginIndex==2" :model="form2" ref="formRef2" :rules="rules2" class="login-form" label-position="left" :hide-required-asterisk='true'>

            <el-form-item prop="checked2" class="mb">
              <el-checkbox v-model="form2.checked2" style="color: rgba(41,40,43,0.6);">已阅读并同意《<a href="user_agreement.html" target="_blank" style="color: #366EF4;">用户协议</a>》和《<a href="private_policy.html" target="_blank" style="color: #366EF4;">隐私政策</a>》</el-checkbox>
            </el-form-item>

            <el-button style="border-radius: 6px !important;" class="w-full" type="primary" @click="login1key">手机号一键登录</el-button>
            <el-form-item prop="tips" class="mb">
              <div style="color: rgba(41,40,43,0.6);text-align: center;">请关闭wifi，使用手机自带浏览器完成登录</div>
            </el-form-item>
          </el-form>
          <el-form v-if="loginIndex==1" :model="form" ref="formRef" :rules="rules" class="login-form" label-position="left" :hide-required-asterisk='true'>
              <div class="d-flex flex-between">
                <el-form-item prop="countryCode" class="mb" style="width: 6rem;">
                  <el-select
                      v-model="form.countryCode"
                      @change="changeCountryCode"
                      clearable
                      filterable
                      size="small"
                      placeholder="国家码">
                    <el-option
                      v-for="(item,index) in countryCodes"
                      :key="index"
                      :label="item.country"
                      :value="item.countryCode"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item prop="username" class="mb" style="flex: 1;">
                  <el-input v-model="form.username" prefix-icon="el-icon-phone" placeholder="请输入手机号" autocomplete="on" class="custom-input-text" clearable />
                </el-form-item>
              </div>
            <el-form-item prop="verifyCode" class="mb">
              <el-input v-model="form.verifyCode" ref="verificationCodeInput" placeholder="请输入验证码" class="custom-input-text" clearable>
                <template slot="append">
                    <el-button @click="startCountdown" :loading="isGetCodeLoading" :disabled="getCaptchaDisabled" class="yanzhengma">
                      {{ getCaptchaDisabled ? `${timeLeft}秒后重发` : '获取验证码' }}
                    </el-button>
                  </template>
                </el-input>
            </el-form-item>
            <el-form-item prop="checked" class="mb">
              <el-checkbox v-model="form.checked" style="color: rgba(41,40,43,0.6);">已阅读并同意《<a href="user_agreement.html" target="_blank" style="color: #366EF4;">用户协议</a>》和《<a href="private_policy.html" target="_blank" style="color: #366EF4;">隐私政策</a>》</el-checkbox>
              <el-checkbox v-if="countryCode1.startsWith('+1')" style="color: rgba(41,40,43,0.6);">我同意接收短信</el-checkbox>
            </el-form-item>
            <el-button style="border-radius: 6px !important;" class="mt w-full" type="primary" @click="handleLogin()" @keydown.native="handleKeyPress()">注册/登录</el-button>
          </el-form>
          <div class="d-flex" style="justify-content: center;font-weight: 400;margin-bottom: 20px;
    margin-top: 10px;
font-size: 14px;
color: #0052D9;">
            <template v-if="$isMobile()&&!isWechat">
              <div class="pointer" @click="loginSwitch(2)" v-if="$isMobile()&&!isWechat">
                手机号一键登录
              </div>
              <div style="margin: 0 10px;">
                |
              </div>
              <div class="pointer" @click="loginSwitch(1)">
                短信登录
              </div>
            </template>
            <template v-if="!$isMobile()">
              <div class="pointer" @click="loginSwitch(0)" v-if="!$isMobile()">
                扫码登录
              </div>
              <div style="margin: 0 10px;">
                |
              </div>
              <div class="pointer" @click="loginSwitch(1)">
                短信登录
              </div>
            </template>
          </div>
    </el-dialog>
</template>
<script>
import { mapState, mapMutations} from 'vuex'
import * as LoginApi from '@/api/auth'
import * as AccountApi from '@/api/account'
export default {
  name: 'Login',
  components: {
  },
  data() {
    return {
      loginIndex: 0,
      intervalIdScan: null,
      expireSeconds: 0,
      ticket: '',
      appid: 'wxe31dc58f2bffc1ac',
      form2: {
        checked2: false,
      },
      form: {
        applicationId: 0,
        username: '',
        phone: '',
        verifyCode: '',
        checked: false,
        countryCode: '+86'
      },
      countryCode1: '+86',
      countryCodes: [
        {"country": "中国", "countryCode": "+86"},
        {"country": "中国香港", "countryCode": "+852"},
        {"country": "中国澳门", "countryCode": "+853"},
        {"country": "中国台湾", "countryCode": "+886"},
        {"country": "美国", "countryCode": "+1"},
        {"country": "俄罗斯", "countryCode": "+7"},
        {"country": "英国", "countryCode": "+44"},
        {"country": "法国", "countryCode": "+33"},
        {"country": "德国", "countryCode": "+49"},
        {"country": "日本", "countryCode": "+81"},
        {"country": "韩国", "countryCode": "+82"},
        {"country": "意大利", "countryCode": "+39"},
        {"country": "加拿大", "countryCode": "+1 "},
        {"country": "澳大利亚", "countryCode": "+61"},
        {"country": "印度", "countryCode": "+91"},
        {"country": "巴西", "countryCode": "+55"},
        {"country": "西班牙", "countryCode": "+34"},
        {"country": "墨西哥", "countryCode": "+52"},
        {"country": "荷兰", "countryCode": "+31"},
        {"country": "瑞士", "countryCode": "+41"},
        {"country": "瑞典", "countryCode": "+46"},
        {"country": "比利时", "countryCode": "+32"},
        {"country": "奥地利", "countryCode": "+43"},
        {"country": "葡萄牙", "countryCode": "+351"},
        {"country": "爱尔兰", "countryCode": "+353"},
        {"country": "挪威", "countryCode": "+47"},
        {"country": "芬兰", "countryCode": "+358"},
        {"country": "丹麦", "countryCode": "+45"},
        {"country": "波兰", "countryCode": "+48"},
        {"country": "土耳其", "countryCode": "+90"},
        {"country": "希腊", "countryCode": "+30"},
        {"country": "南非", "countryCode": "+27"},
        {"country": "以色列", "countryCode": "+972"},
        {"country": "阿联酋", "countryCode": "+971"},
        {"country": "沙特阿拉伯", "countryCode": "+966"},
        {"country": "卡塔尔", "countryCode": "+974"},
        {"country": "科威特", "countryCode": "+965"},
        {"country": "埃及", "countryCode": "+20"},
        {"country": "阿根廷", "countryCode": "+54"},
        {"country": "哥伦比亚", "countryCode": "+57"},
        {"country": "智利", "countryCode": "+56"},
        {"country": "马来西亚", "countryCode": "+60"},
        {"country": "泰国", "countryCode": "+66"},
        {"country": "新加坡", "countryCode": "+65"},
        {"country": "印度尼西亚", "countryCode": "+62"},
        {"country": "菲律宾", "countryCode": "+63"},
        {"country": "新西兰", "countryCode": "+64"},
        {"country": "乌克兰", "countryCode": "+380"},
        {"country": "匈牙利", "countryCode": "+36"}
      ],
      rules2: {
        checked2: [
          {validator: this.customValidatePolicy, trigger: ['blur','change']}
        ],
      },
      rules: {
        username: [
          {validator: this.customValidateUsername, trigger: ['blur','change']}
        ],
        countryCode: [
          { required: true, message: '请选择国家码', trigger: ['blur','change'] }
        ],
        checked: [
          {validator: this.customValidatePolicy, trigger: ['blur','change']}
          // { required: true, message: '请阅读并同意以上协议', trigger: ['blur','change'] }
        ],
        verifyCode: [
          { required: true, message: '请输入验证码', trigger: ['blur','change'] },
          { min: 6, max: 6, message: '验证码长度必须为6位', trigger: ['blur','change'] }
        ]
      },
      isFormValid: true,
      isGetCodeLoading: false,
      getCaptchaDisabled: false,
      timeLeft: 60, // 初始倒计时时间
      intervalId: null, // 用于存储定时器的 ID
      account: {}
    }
  },
  computed: {
    ...mapState(['user', 'story', 'showLoginDialogFlag', 'urlquery']),
    drawerWidth() {
      return window.innerWidth <= 768 ? '90%' : '21%';
    },
    dialogTop() {
      return window.innerWidth <= 768 ? "20vh" : '10vh';
    },
    dialogTitle () {
      return this.story.id ? '故事设置' : '新建故事'
    },
    showHeader() {
      return window.innerWidth <= 768
    },
    isWechat() {
      return window.navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
    }
  },
  created() {

  },
  mounted() {
    console.log('this.$isMobile()', this.$isMobile());
    if(this.$isMobile()){
      if(this.isWechat){
        this.loginSwitch(1)
      }else{
        this.loginSwitch(2)
      }
    }else{
      this.loginSwitch(0)
    }
  },
  methods: {
    ...mapMutations(['setStory', 'setUser', 'setToken', 'setShowLoginDialogFlag', 'setShowVideoFlag', 'setIsAuthenticated']),
    close(){
      this.setShowLoginDialogFlag(false);
    },
    login1key(){
      // 判断 checked2
      this.$refs['formRef2'].validate((valid) => {
        console.log('valid2', valid);
        if (valid) {
          this.loginForYD();
        }else{
          console.log('表单验证失败');
        }
      });
    },
    async loginSwitch(index) {
      if(this.intervalIdScan){
        clearInterval(this.intervalIdScan);
      }
      this.loginIndex = index
      this.ticket = ''
      this.expireSeconds = 0
      if(this.loginIndex == 0){
        this.getTemporaryQrcode()
      }else if(this.loginIndex == 1){

      }else if(this.loginIndex == 2){

      }
    },
    async loginForYD() {
      const res = await LoginApi.ecloudSign({ appid: '300012963603', urlquery: localStorage.urlquery })
      let result = res.data
      if (result.code === 0) {
        let appId = result.data.appId
        let traceId = result.data.traceId
        let sign = result.data.sign
        let version = result.data.version
        let timestamp = result.data.timestamp
        console.log('ecloudSign ', result)
        YDRZAuthLogin.getTokenInfo({
        	data: { //请求的参数
        		version: version, //接口版本号 （必填）
        		appId: appId, //应用Id （必填）
        		sign: sign, //加密后的sign（必填）。sign生成规则： MD5(appId + businessType + msgId + timestamp + traceId + version + appkey)	注： msgID要和traceID保持一致， 此处sign与token校验接口sign的生成规则不同
        		traceId: traceId, //业务方生成唯一标识
        		timestamp: timestamp, //请求消息发送的系统时间，精确到毫秒，共17位，格式：20121227180001165
        		openType: '1', //取号类型
        		expandParams: '', //扩展参数 格式：参数名=值 多个时使用 \| 分割 （选填）
        		authPageType: '0', //若值为“1”时展示弹窗，若值为“2”时展示自定义弹窗版，若值为“3”时展示自定义页面版，若为其它值则展示页面
        	},
        	//成功回调
        	success: (res) => {
            console.log('success ', res);
            // alert('success：'+JSON.stringify(res))
            let msgId = res.msgId
            let token = res.token
            let userInformation = res.userInformation
            LoginApi.ecloudPhone({ appid: appId, token, msgId, userInformation, urlquery: localStorage.urlquery }).then((res2)=>{
              // alert(JSON.stringify(res2));
              let result2 = res2.data
              // alert(JSON.stringify(result2));
              if (result2.code === 0) {
                // 返回 account
                this.account = result2.data
                // alert(JSON.stringify(this.account));
                this.loginInit()
              }
            })
          },
        	//错误回调
        	error: (res) => {
            console.log('error ', res);
            const ua = navigator.userAgent.toLowerCase();
            if (ua.includes('micromessenger')) {
              this.$message.error("因微信限制，无法使用一键登录，请用短信登录或外部浏览器重试。");
            } else {
              // alert(JSON.stringify(res))
              // if(res.code == 504){
              //   this.$message.error("请使用手机移动网络，不支持WiFi！")
              // }else if(res.YDData && res.YDData.code == '103111'){
              //   this.$message.error("请使用手机移动网络，不支持WiFi！")
              // }
              this.$message.error("请使用手机移动网络，不支持WiFi！");
            }
          },
        	//authPageType等于2时可以通过该回调方法监听，用户输入中间四位号码并勾选协议后触发
        	layerCallback: (res) => {
            console.log('layerCallback ', res);
          }
        })
      }
    },
     async getTemporaryQrcode() {
       // 调用后端API
       const res = await LoginApi.getTemporaryQrcode({ appid: this.appid, urlquery: localStorage.urlquery })
       let result = res.data
       if (result.code === 0) {
         this.ticket = result.data.ticket
         this.expireSeconds = result.data.expireSeconds
         this.intervalIdScan = setInterval(this.periodicTask, 2000);
       }
     },
    loginInit(){
      localStorage.setItem('lyToken', this.account.token)
      localStorage.setItem('lyAccount', JSON.stringify(this.account))

      this.$store.commit('setToken', this.account.token)
      this.$store.commit('setUser', this.account)

      // 登录状态
      this.$store.commit('setIsAuthenticated', this.account.token != '')
      this.$router.push('/home')
      this.$parent.handleNewerGift();
      this.close()
      this.form.username = ''
      this.form.phone = ''
      this.form.verifyCode = ''
      this.form.countryCode = ''
    },
    changeCountryCode(val){
      console.log('val', val);
      this.countryCode1 = val
    },
    customValidateUsername(rule, value, callback) {
      // console.log('rule:', rule, 'value:', value);
      // 根据表单数据执行不同的验证
      if (this.form.username.length <= 0) {
        callback(new Error('请输入手机号！'));
      } else if (this.form.countryCode.startsWith('+86')) {
        const regex = /^1[3-9]\d{9}$/;
        if(!regex.test(value)){
          callback(new Error('手机号格式有误！'));
        } else {
          callback();
        }
      } else if (this.form.countryCode.startsWith('+886')) {//台湾
        const regex = /^09\d{8}$/;
        if(!regex.test(value)){
          callback(new Error('手机号格式有误！'));
        } else {
          callback();
        }
      } else if (this.form.countryCode.startsWith('+852')) {//HK
        const regex = /^[569]\d{7}$/;
        if(!regex.test(value)){
          callback(new Error('手机号格式有误！'));
        } else {
          callback();
        }
      } else if (this.form.countryCode.startsWith('+853')) {//澳门
        const regex = /^6\d{7}$/;
        if(!regex.test(value)){
          callback(new Error('手机号格式有误！'));
        } else {
          callback();
        }
      } else if (this.form.countryCode.startsWith('+1')) {//US
        const regex = /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
        if(!regex.test(value)){
          callback(new Error('手机号格式有误！'));
        } else {
          callback();
        }
      } else if (this.form.countryCode.startsWith('+44')) {//UK
        const regex = /^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:7(?:[45789]\d|624))|(?:1[2-9]\d{2}))\)?[\s-]?\d{3}[\s-]?\d{3,4}$/;
        if(!regex.test(value)){
          callback(new Error('手机号格式有误！'));
        } else {
          callback();
        }
      } else if (this.form.countryCode.startsWith('+82')) {//kerea
        const regex = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;
        if(!regex.test(value)){
          callback(new Error('手机号格式有误！'));
        } else {
          callback();
        }
      } else if (this.form.countryCode.startsWith('+81')) {//japan
        const regex = /^(0[789]0)[0-9]{8}$|^(0[789]0)[0-9]{9}$/;
        if(!regex.test(value)){
          callback(new Error('手机号格式有误！'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    customValidatePolicy(rule, value, callback) {
      // console.log('rule:', rule, 'value:', value);
      // 根据表单数据执行不同的验证
      if (this.form.checked || this.form2.checked2) {
        callback();
      } else {
        callback(new Error('请阅读并同意以上协议'));
      }
    },
    handleKeyPress(event) {
      // 检查按下的键是否是回车键
      if (event.key === 'Enter') {
        // 执行你想要的操作，例如提交表单
        this.handleLogin();
      }
    },
    debugLogin() {
      let token = 'eyJhbGciOiJIUzI1NiJ9.eyJhdmF0YXJJZCI6Ii9hdmF0YXIvMTIzNDU2LnBuZyIsImlkIjoxOTIwMjE1MjE3Njk5NDAxNzI5fQ.8FfUfRJoeG3nNy8Modu3pSJXYm-rruS6Dot38GL1zDA'
      localStorage.setItem('lyToken', token)
      AccountApi.view('1920215217699401729')
          .then(res => {
            // 登录成功
            if (res.data.code === 0) {
              this.account = res.data.data
              this.account.token = token
              console.log('debugLogin', this.account);
              localStorage.setItem('lyToken', this.account.token)
              localStorage.setItem('lyAccount', JSON.stringify(this.account))

              this.$store.commit('setToken', this.account.token)
              this.$store.commit('setUser', this.account)

              // 登录状态
              this.$store.commit('setIsAuthenticated', this.account.token != '')
              this.$router.push('/home')
              // 调用 this.handleNewerGift();
              this.$parent.handleNewerGift();
              this.close()
              this.form.username = ''
              this.form.phone = ''
              this.form.verifyCode = ''
              this.form.countryCode = ''
            }
          })
    },
    handleLogin() {
      // this.debugLogin();return;

      // let md5 = require('md5')
      let params = Object.assign({}, this.form)
      params.urlquery = localStorage.urlquery
      // params.verifyCode = md5(this.form.verifyCode)
      params.countryCode = this.form.countryCode.trim()
      this.$refs['formRef'].validate((valid) => {
        console.log('valid', valid);
        if (valid) {
          LoginApi.loginByFrom(params)
              .then(res => {
                // 登录成功
                if (res.data.code === 0) {
                  this.account = res.data.data
                  console.log('handleLogin', this.account);
                  localStorage.setItem('lyToken', this.account.token)
                  localStorage.setItem('lyAccount', JSON.stringify(this.account))

                  this.$store.commit('setToken', this.account.token)
                  this.$store.commit('setUser', this.account)

                  // 登录状态
                  this.$store.commit('setIsAuthenticated', this.account.token != '')
                  this.$router.push('/home')
                  // 调用 this.handleNewerGift();
                  this.$parent.handleNewerGift();
                  this.close()
                  this.form.username = ''
                  this.form.phone = ''
                  this.form.verifyCode = ''
                  this.form.countryCode = ''
                }
              })
        }else{
          console.log('表单验证失败');
        }
      });
    },
    startCountdown() {
      this.isGetCodeLoading = true
      this.isFormValid = true;
      if (this.intervalId) {
        clearInterval(this.intervalId); // 如果已经有一个定时器在运行，先清除
      }
      this.$refs.formRef.clearValidate('countryCode');
      this.$refs.formRef.validateField('countryCode', (message) => {
        console.log('countryCode', message);
        if (message) {
          this.isFormValid = false;
          this.isGetCodeLoading = false
        }
      });

      this.$refs.formRef.clearValidate('username');
      this.$refs.formRef.validateField('username', (message) => {
        if (message) {
          this.isFormValid = false;
          this.isGetCodeLoading = false
        }
      });

      setTimeout(()=>{
        if (this.isFormValid) {
          this.form.phone = this.form.username
          let param = Object.assign({}, this.form)
          param.countryCode = param.countryCode.trim()
          LoginApi.getVerifycode(param)
            .then(res => {
              // 获取成功
              if (res.data.code === 0) {
                this.getCaptchaDisabled = true;
                this.isGetCodeLoading = false
                this.intervalId = setInterval(() => {
                  if (this.timeLeft > 0) {
                    this.timeLeft--; // 每秒减少 1
                  } else {
                    clearInterval(this.intervalId); // 倒计时结束，清除定时器
                    this.timeLeft = 60; // 重置倒计时时间
                    this.getCaptchaDisabled = false;
                  }
                }, 1000);

                this.$nextTick(() => {
                  this.$refs.verificationCodeInput.focus();
                });
              }else{
                this.getCaptchaDisabled = false;
                this.isGetCodeLoading = false
              }
            })
        } else {
          console.log('手机号码验证失败');
          this.getCaptchaDisabled = false;
          this.isGetCodeLoading = false
          return false
        }
      }, 1000);
    },
    // 定义需要周期执行的函数
    async periodicTask() {
      const taskSuccess = await this.doTask();
      if (taskSuccess && this.intervalIdScan) {
        this.$nextTick(()=>{
          this.loginInit()
        })
        clearInterval(this.intervalIdScan);
      }
    },
    async doTask() {
      if(this.ticket == ''){
        return false;
      }
      let res = await LoginApi.loginLoop({appid: this.appid, ticket: this.ticket});
      if(res.data.code == 0 && res.data.data){
        // 返回 account
        this.account = res.data.data
         return true;
      }else{
        return false;
      }
    }
  },
  beforeDestroy() {
    if(this.intervalIdScan){
      clearInterval(this.intervalIdScan);
    }
  },
}
</script>
<style>
@media (min-width: 768px) {
  .custom-dialog-login .el-dialog {
    min-width: 350px !important; /* 小屏幕时占满宽度 */
  }
}
.el-input--small .el-input__inner {
  height: 40px !important;
  line-height: 40px !important;
}

</style>
<style scoped lang="scss">
.login-form{
  color: #ffffff;
  padding: 1rem 0;
}
/deep/ .el-form-item__label-wrap .el-form-item__label {
  color: #ffffff !important;
}
.mt {
  margin-top: 1rem !important;
}
.mb {
  margin-bottom: 1rem !important;
}
/deep/  .yanzhengma.el-button {
  background-color: #ffffff; /* 设置背景颜色 */
  border: none; /* 设置边框宽度、样式和颜色 */
  box-shadow: none;
  cursor: pointer; /* 鼠标悬停时显示指针手势 */
  // border: 1px solid #5C5A5A;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
}
/deep/ .custom-input-text .el-button--default {
  background-color: #ffffff; /* 设置背景颜色 */
}
/deep/ .custom-dialog .el-dialog__wrapper {
  background-color: rgba(0, 0, 0, 0.01) !important;
}
</style>
